import request from '@/http/request'

export const getEmailPage = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-email/api/email/search`, {
    params
  })
}
export const modifyStatus = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/email/modifyStatus`, params)
}
export const addOrEditEmail = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/email/addOrEditEmail`, params, {
    hiddenError: true
  })
}
export const sendEmail = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/email/send-email`, params)
}

export const resendEmail = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/email/resend-email`, {}, { params })
}
